import React from 'react'
import Page from '../../component/page'
import DiscGolfApp from '../../component/DiscGolfApp'
import Slider from './Slider'
import WorldChart from './WorldChart'

function Home() {
  return (
    <Page className="home">
      <Slider />
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-6 col-sm-12 feature">
            <i className="icon-frame bi-phone"></i>
            <h3>Android</h3>
            <p>
              DiscGolf is the ultimate companion app for disc golf enthusiasts worldwide. Track your rounds with digital scorecards, navigate courses with detailed maps, and analyze your performance with comprehensive statistics—all from your Android device. Designed to enhance your disc golf experience whether you're a casual player or tournament competitor.
            </p>
            <p>
              <DiscGolfApp>Get DiscGolf for Android</DiscGolfApp>
            </p>
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12 feature">
            <i className="icon-frame bi-watch"></i>
            <h3>Wear OS</h3>
            <p>
              Take your disc golf experience to the next level with our seamless Wear OS integration. Keep score for your entire group directly from your smartwatch, track throws in real-time, and focus on your game without reaching for your phone. The perfect hands-free companion for serious players.
            </p>
            <p>
              <DiscGolfApp>Get DiscGolf for Android</DiscGolfApp>
            </p>
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12 feature">
            <i className="icon-frame bi-globe"></i>
            <h3>Web</h3>
            <p>
              Access the power of DiscGolf right from your browser—completely free for all players. View detailed course maps, and print custom scorecards. Your essential disc golf toolkit, available anywhere you have internet access.
            </p>
          </div>
        </div>
      </div>
      <WorldChart />
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div id="news-content">
              {/* <?php
                    for($i=0; $i<count($news) && $i<$NEWS_HISTORY_COUNT; $i++){
                        printNews($news[$i]);
                    }
                ?> */}
            </div>
          </div>
        </div>
      </div>
    </Page>
  )
}

export default Home
